import Tabs from "./Tabs"
import TabsContent from "./TabsContent"
import TabsList from "./TabsList"
import TabsTrigger from "./TabsTrigger"

export type { TabsProps } from "./Tabs"
export type { TabsContentProps } from "./TabsContent"
export type { TabsListProps } from "./TabsList"
export type { TabsTriggerProps } from "./TabsTrigger"

export default Object.assign(Tabs, {
  Content: TabsContent,
  List: TabsList,
  Trigger: TabsTrigger,
})
